import { AccountingMovementsForm } from "../../components";

const AccountingMovementsCreate = () => {
  return <AccountingMovementsForm />;
};

export default AccountingMovementsCreate;
